import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface AppState {
  sidebarCollapsed: boolean
  toggleSidebar: () => void
}

export const useAppStore = create<AppState>()(
  devtools(
    set => ({
      sidebarCollapsed: false,
      toggleSidebar: () =>
        set(state => ({
          sidebarCollapsed: !state.sidebarCollapsed,
        })),
    }),
    { name: 'coobird-app' }
  )
)
